// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QkQa","name":"styles_name__21dQS","phone":"styles_phone__3T7WD"};